export interface FactoryListing {
  id: string;
  title: string;
  image: string;
  category: string;
  price: number;
  stock: number;
  commission: number;
  status: "active" | "paused" | "draft";
  totalSales: number;
  totalRevenue: number;
  views: number;
  badge: string;
  createdAt: string;
}

export interface FactoryLead {
  id: string;
  title: string;
  category: string;
  country: string;
  countryFlag: string;
  quantity: string;
  budget: string;
  description: string;
  targetDelivery: string;
  postedAt: string;
  buyerName: string;
  email: string;
  whatsapp: string;
  company: string;
  status: "new" | "quoted" | "negotiating" | "closed";
  matchScore: number;
}

export const mockFactoryListings: FactoryListing[] = [
  {
    id: "1",
    title: "Premium Wireless Earbuds Pro X200",
    image: "https://public.readdy.ai/ai/img_res/21255a2c1532bd7ae16d4cc60225bf53.jpg",
    category: "Electronics",
    price: 49.99,
    stock: 500,
    commission: 12,
    status: "active",
    totalSales: 2341,
    totalRevenue: 116987.59,
    views: 18420,
    badge: "Best Seller",
    createdAt: "2026-01-15",
  },
  {
    id: "6",
    title: "Portable Bluetooth Speaker IPX7",
    image: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod6&orientation=squarish",
    category: "Electronics",
    price: 39.99,
    stock: 450,
    commission: 10,
    status: "active",
    totalSales: 2089,
    totalRevenue: 83537.11,
    views: 14200,
    badge: "Flash Sale",
    createdAt: "2026-02-03",
  },
  {
    id: "3",
    title: "Smart LED Desk Lamp with USB-C",
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod3&orientation=squarish",
    category: "Home",
    price: 28.99,
    stock: 800,
    commission: 8,
    status: "active",
    totalSales: 987,
    totalRevenue: 28613.13,
    views: 7890,
    badge: "New Arrival",
    createdAt: "2026-03-10",
  },
  {
    id: "9",
    title: "4K Action Camera Waterproof 60fps",
    image: "https://readdy.ai/api/search-image?query=4K%20action%20camera%20compact%20waterproof%20black%20clean%20white%20background%20product%20photography%20studio%20minimal&width=400&height=400&seq=prod9&orientation=squarish",
    category: "Electronics",
    price: 89.99,
    stock: 0,
    commission: 14,
    status: "paused",
    totalSales: 412,
    totalRevenue: 37075.88,
    views: 5340,
    badge: "",
    createdAt: "2026-01-28",
  },
  {
    id: "10",
    title: "Noise Cancelling Headphones Studio Pro",
    image: "https://readdy.ai/api/search-image?query=noise%20cancelling%20over%20ear%20headphones%20black%20studio%20professional%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod10&orientation=squarish",
    category: "Electronics",
    price: 129.99,
    stock: 200,
    commission: 15,
    status: "draft",
    totalSales: 0,
    totalRevenue: 0,
    views: 0,
    badge: "",
    createdAt: "2026-04-10",
  },
];

export const mockFactoryLeads: FactoryLead[] = [
  {
    id: "br1",
    title: "Wireless Earbuds — 5,000 Units Bulk Order",
    category: "Electronics",
    country: "United Kingdom",
    countryFlag: "🇬🇧",
    quantity: "5,000 units",
    budget: "$180,000 – $220,000",
    description: "Looking for a verified factory to supply 5,000 units of premium wireless earbuds with ANC. Must have CE certification, IPX5 rating, and Bluetooth 5.0+. OEM branding required. Sample order of 50 units first.",
    targetDelivery: "June 2026",
    postedAt: "2026-04-10",
    buyerName: "James Whitfield",
    email: "james.whitfield@uktech.co.uk",
    whatsapp: "+44 7911 123456",
    company: "UKTech Distribution Ltd.",
    status: "new",
    matchScore: 98,
  },
  {
    id: "br6",
    title: "Bluetooth Speakers — 3,000 Units",
    category: "Electronics",
    country: "Japan",
    countryFlag: "🇯🇵",
    quantity: "3,000 units",
    budget: "$80,000 – $110,000",
    description: "Japanese electronics retailer seeking IPX7 portable Bluetooth speakers. PSE certification required. Japanese language packaging. Prefer factory with Japan export experience and fast turnaround.",
    targetDelivery: "June 2026",
    postedAt: "2026-04-05",
    buyerName: "Kenji Tanaka",
    email: "k.tanaka@techshop.jp",
    whatsapp: "+81 90 1234 5678",
    company: "TechShop Japan Co., Ltd.",
    status: "quoted",
    matchScore: 94,
  },
  {
    id: "br4",
    title: "LED Desk Lamps — 8,000 Units",
    category: "Home",
    country: "Germany",
    countryFlag: "🇩🇪",
    quantity: "8,000 units",
    budget: "$160,000 – $200,000",
    description: "German office supply company looking for smart LED desk lamps with USB-C charging. CE marking required. Must support 220V. White-label branding. Prefer factory with EU export experience.",
    targetDelivery: "August 2026",
    postedAt: "2026-04-07",
    buyerName: "Klaus Müller",
    email: "k.mueller@buerotech.de",
    whatsapp: "+49 151 23456789",
    company: "BüroTech GmbH",
    status: "negotiating",
    matchScore: 87,
  },
  {
    id: "br7",
    title: "Smart Home Hub Devices — 2,000 Units",
    category: "Electronics",
    country: "USA",
    countryFlag: "🇺🇸",
    quantity: "2,000 units",
    budget: "$60,000 – $90,000",
    description: "US-based smart home startup looking for a factory partner to produce WiFi-enabled smart home hubs. Must support Alexa and Google Home integration. FCC certification required. Looking for long-term partnership.",
    targetDelivery: "October 2026",
    postedAt: "2026-04-11",
    buyerName: "Rachel Kim",
    email: "rachel@smarthomeco.com",
    whatsapp: "+1 415 555 0198",
    company: "SmartHome Co. Inc.",
    status: "new",
    matchScore: 82,
  },
  {
    id: "br8",
    title: "TWS Earbuds Budget Line — 10,000 Units",
    category: "Electronics",
    country: "Brazil",
    countryFlag: "🇧🇷",
    quantity: "10,000 units",
    budget: "$120,000 – $150,000",
    description: "Brazilian electronics distributor seeking budget TWS earbuds for mass market. ANATEL certification required. Portuguese packaging. Competitive pricing is key. Overseas warehouse shipping acceptable.",
    targetDelivery: "July 2026",
    postedAt: "2026-04-09",
    buyerName: "Lucas Ferreira",
    email: "lucas@techbrasil.com.br",
    whatsapp: "+55 11 91234 5678",
    company: "TechBrasil Distribuidora Ltda.",
    status: "new",
    matchScore: 79,
  },
];

export const mockFactoryStats = {
  totalRevenue: 266213.71,
  revenueChange: 18.4,
  totalOrders: 5829,
  ordersChange: 12.1,
  activeListings: 3,
  newLeads: 3,
  avgCommission: 11.8,
  fulfillmentRate: 99.2,
  totalViews: 45850,
  viewsChange: 24.7,
};
